
// if ($(window).width() > 1200) {
//     var section1_4TL =  new TimelineMax()
//                         .to(".section-1-4 img", 1, { yPercent: 20 }, "start")
//                         .to(".section-1-4 .big-title", 1, { yPercent: -50 }, "start")
//                         .to(".section-1-4 .quote-1", 1, { yPercent: 30 }, .5)
//                         .to(".section-1-4 .quote-2", 1, { yPercent: -60 }, .5)
//                         .to(".section-1-4 .quote-paper", 1, { yPercent: -40 }, 1)
//                         .to(".section-1-4 .quote-3", 1, { yPercent: -60 }, 1.5)
//                         .from(".section-1-4 .quote-4", 1, { yPercent: 20 }, 1.5);
    
    
//     var scene = new ScrollMagic.Scene({
//             triggerElement: ".section-1-4",
//             triggerHook: .5,
//             duration: $(".section-1-4").height()
//         })
//         .setTween(section1_4TL)
//         .addTo(require('../scrollInit'));
// }

$('.section-1-4 .list-quote').slick({
    dots       : true,
    mobileFirst: true,
    infinite   : false,
    arrows     : false,
    // adaptiveHeight: true,
});